let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kpI3X")).then(() => parcelRequire('dC7Oa'));